exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-partials-resetpasswordprompt__login{display:inline-block;text-align:left;-webkit-transition:height 1s linear;-ms-transition:height 1s linear;transition:height 1s linear}.nil-sa-partials-resetpasswordprompt__errorMessage{color:red;padding-bottom:10px}.nil-sa-partials-resetpasswordprompt__errorSpacing{height:26px}.nil-sa-partials-resetpasswordprompt__resetSent{color:#008e40;font-size:22px;margin-bottom:20px}.nil-sa-partials-resetpasswordprompt__buttonSpinner{font-size:30px;color:#000!important}.nil-sa-partials-resetpasswordprompt__searchButton{margin-top:35px}.nil-sa-partials-resetpasswordprompt__searchButton button{width:100%;font-size:16px}.nil-sa-partials-resetpasswordprompt__resetPassword{color:#388efb;cursor:pointer}.nil-sa-partials-resetpasswordprompt__resetPassword:hover{color:#2c71cd}", ""]);

// exports
exports.locals = {
	"login": "nil-sa-partials-resetpasswordprompt__login",
	"errorMessage": "nil-sa-partials-resetpasswordprompt__errorMessage",
	"errorSpacing": "nil-sa-partials-resetpasswordprompt__errorSpacing",
	"resetSent": "nil-sa-partials-resetpasswordprompt__resetSent",
	"buttonSpinner": "nil-sa-partials-resetpasswordprompt__buttonSpinner",
	"searchButton": "nil-sa-partials-resetpasswordprompt__searchButton",
	"resetPassword": "nil-sa-partials-resetpasswordprompt__resetPassword"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/partials/ResetPasswordPrompt/index.less
// module id = 450
// module chunks = 0